export default __webpack_public_path__ + "static/media/icons_dashboard.484b8fd0.svg";